export const initialState = {
  fetch: false,
  data: null,
  res: null,
  err: null,
  isOpen: false,
  isOpenCompany: false,
  isOpenPrivacyPolicy: false,
  pendingAuth: null as any,
};

export const initialAction = {
  type: "DEFAULT",
  data: null,
};

export const PRIVACY_POLICY_CONTENT = `Privacy Policy

PT Pelabuhan Indonesia (Persero) and/or its affiliates ("the Company") are committed to protecting the privacy and security of your personal data.

1. Data Collection
We collect personal data that you provide when using the Lintas platform, including but not limited to your name, email address, phone number, and company information.

2. Use of Data
The data collected is used to:
- Provide and improve Lintas platform services
- Process your transactions and requests
- Send service-related notifications
- Comply with applicable laws and regulations

3. Data Security
We implement appropriate technical and organizational security measures to protect your personal data from unauthorized access, disclosure, alteration, or destruction.

4. Data Sharing
We do not sell or rent your personal data to third parties. Data may only be shared with trusted partners who assist in service operations, subject to strict confidentiality obligations.

5. User Rights
You have the right to access, correct, or delete your personal data in accordance with applicable laws and regulations.

6. Policy Changes
This privacy policy may be updated from time to time. Users will be notified and asked for re-consent periodically in accordance with company policy.

By agreeing to this policy, you acknowledge that you have read, understood, and agreed to the collection and use of your personal data as described above.`;
